/**
 * this file contains all redux-saga watchers & workers for the transaction
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 19/06/18
 */

import { takeEvery, select, put } from 'redux-saga/effects'

// import action creators
import { setOpenRightMenu } from '../actions/componentActions'

import C from '../constants'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE LIST OF TRANSACTIONS
----------------------------------------------------------------------------- */






// watcher saga for changing the left menu status
export function* watchOpenLeftMenu() {
    yield takeEvery(C.SET_OPEN_LEFT_MENU, workerOpenLeftMenu)
}

// worker saga for closing right menu on opening left menu
function* workerOpenLeftMenu() {
    // get the store content
    const state = yield select()
    if(state.componentState.openLeftMenu)
        yield put(setOpenRightMenu(false))
}
  


// WEBPACK FOOTER //
// ./src/sagas/componentSaga.js